// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__1xv93","initiative":"style_initiative__1B9Ct"};